import React, { useState } from "react";
import { activateLicense } from "../services/licenseApi";

/**
 * Shown when this browser/PC has no valid DigitalEye license.
 */
export default function ActivateLicensePage({ onActivated }) {
  const [licenseKey, setLicenseKey] = useState("");
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiError("");

    const nextErrors = {};
    if (!licenseKey.trim()) {
      nextErrors.licenseKey = "License key is required";
    }

    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors);
      return;
    }

    setErrors({});
    setLoading(true);
    try {
      const result = await activateLicense({
        licenseKey: licenseKey.trim(),
      });
      if (typeof onActivated === "function") {
        onActivated(result);
      }
    } catch (err) {
      setApiError(err?.message || "License activation failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left-panel">
        <div className="login-branding">
          <h2 className="brand-subtitle">Next Gen Command & Control</h2>
        </div>
      </div>

      <div className="login-right-panel">
        <div className="login-form-container">
          <h1 className="form-title">
            <img
              src="/images/omni_logo.png"
              alt="Oomni Watch"
              className="logo-image"
            />
          </h1>

          <h2 className="form-subtitle" style={{ marginBottom: 8 }}>
            Activate License
          </h2>
          <p className="form-description" style={{ marginBottom: 24 }}>
            Enter a valid DigitalEye license key to unlock the application.
          </p>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <input
                type="text"
                name="licenseKey"
                value={licenseKey}
                onChange={(e) => {
                  setLicenseKey(e.target.value);
                  if (errors.licenseKey) {
                    setErrors((prev) => ({ ...prev, licenseKey: "" }));
                  }
                  if (apiError) setApiError("");
                }}
                className={errors.licenseKey ? "error" : ""}
                placeholder="License Key"
                disabled={loading}
                autoComplete="off"
                spellCheck={false}
              />
              {errors.licenseKey ? (
                <span className="error-message">{errors.licenseKey}</span>
              ) : null}
            </div>

            {apiError ? <div className="error-alert">{apiError}</div> : null}

            <button type="submit" className="login-button" disabled={loading}>
              {loading ? "Activating..." : "Activate License"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
